import { Component,ViewChild, OnInit,Output, Input,HostListener,EventEmitter,ElementRef } from '@angular/core';
import { ListService } from '../../../services/list.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Global } from '../../../shared/global';
import { Repository } from '../../../services/repository'
import { NgSelectComponent } from '@ng-select/ng-select';
import 'jquery'
import 'bootstrap'


const swal = require('sweetalert');
@Component({
    selector: 'app-dm-khachhangedit',
    templateUrl: './khachhangedit.component.html',
    //templateUrl: 'ClientApp/routes/DanhMuc/data/data.component.html',
    styleUrls: ['./khachhangedit.component.scss'],
    providers: [ListService, Repository]
})


export class khachhangeditComponent implements OnInit {

   
    
  quyen_them: boolean = false;
  quyen_sua: boolean = false;
  quyen_xoa: boolean = false;
  inputparents: any;
  inputquanhegiaodichs: any = [
    { Id: 1, Ma_Doi_Tuong: '1', Ten_Doi_Tuong: 'Trong đơn vị kế toán trung gian 2' }
    , { Id: 2, Ma_Doi_Tuong: '2', Ten_Doi_Tuong: 'Trong đơn vị kế toán trung gian 1' }
    , { Id: 3, Ma_Doi_Tuong: '3', Ten_Doi_Tuong: 'Trong đơn vị dự toán cấp 1' }
    , { Id: 4, Ma_Doi_Tuong: '4', Ten_Doi_Tuong: 'Ngoài đơn vị dự toán cấp 1 - trong cùng 1 tỉnh' }
    , { Id: 5, Ma_Doi_Tuong: '5', Ten_Doi_Tuong: 'Ngoài đơn vị dự toán cấp 1 (khác tỉnh, khác Bộ, ngành) - trong lĩnh vực kế toán nhà nước' }
    , { Id: 6, Ma_Doi_Tuong: '6', Ten_Doi_Tuong: 'Ngoài khu vực nhà nước' }
  ];
    indLoading: boolean = false;    
    doituongSelect: any = { Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null,Ghi_Chu: null,Parent:null,Trang_Thai:null,Nhom_Doi_Tuong_ID:null,Don_Vi_Id:null,Ma_Ao:null,
      To_Chuc: false, Gioi_Tinh: null, Dia_Chi: null, Ngay_Sinh: null, Ngay_Sinh_S: null, Dien_Thoai: null, CMND_Ngay: null, CMND_NoiCap: null, CMND_So: null, Hom_Thu: null, Fax: null,
      Dien_Thoai_Nha: null, Dien_Thoai_Co_Quan: null, Ma_So_Thue: null, La_Nguoi_Lien_Lac: null, Tai_Khoan_Ngan_Hang: null, Ten_Ngan_Hang: null, CallForm: null
      , Quan_He_Giao_Dich: null
    };    
    nhomdtid:string=null;

    @ViewChild('slCapTren',{static:false}) slCapTren: NgSelectComponent;
    @Output() save: EventEmitter<any> = new EventEmitter();
  
   

    constructor( private _dataService: ListService, private repo: Repository) {
       
        
    }

    ngOnInit(): void {
       
    }

    // @HostListener('document:keydown', ['$event'])
    // public handleKeyboardEvent(event: KeyboardEvent): void {
      
    //   if(event.key==="F9")
    //   {
    //       this.saveproduct();
    //   }
    //   event.stopPropagation();
     
    // }

    comboSearchFn(term: string, item: any) {
        term = term.toLowerCase();
        return item.Ma_Doi_Tuong.toLowerCase().indexOf(term) > -1 || item.Ten_Doi_Tuong.toLowerCase().indexOf(term) > -1;
    }
  @ViewChild("mafocus", { static: false }) mafocus: ElementRef;
  callForm: any;
  loadDataInit(nhomdoituongid: string, id: string, donviid: string)
  {
    this.loadDataInit1(nhomdoituongid, id, donviid);
  }
  loadDataInit2(nhomdoituongid: string, id: string, donviid: string, tentruong: any) {
    this.callForm = tentruong;
    this.loadDataInit1(nhomdoituongid, id, donviid);
  }
  loadDataInit1(nhomdoituongid: string, id: string, donviid: string)
  {
      var authlogin = localStorage.getItem('currentUser');
      if (authlogin) {

        let data = JSON.parse(authlogin);
        var giatri = data.ds_quyen.filter(name => name.id === nhomdoituongid.toLowerCase());
        if (giatri != null && giatri.length > 0) {
          if (giatri[0].them == true)
            this.quyen_them = true;
          else
            this.quyen_them = false;
          if (giatri[0].sua == true)
            this.quyen_sua = true;
          else
            this.quyen_sua = false;
          if (giatri[0].xoa == true)
            this.quyen_xoa = true;
          else
            this.quyen_xoa = false;
        }
      }    
        this.nhomdtid = nhomdoituongid;
        setTimeout(() => {
            this.mafocus.nativeElement.focus();  
        },500);
        this.repo.getRequest("api/doituong/getall2/" + nhomdoituongid + '/null/'+donviid)
        .subscribe(response => {            
            this.inputparents=response;
        });
        this.doituongSelect ={ Id: null, Ma_Doi_Tuong: null, Ten_Doi_Tuong: null,Ghi_Chu: null,Parent:null,Trang_Thai:true,Nhom_Doi_Tuong_ID:nhomdoituongid,Don_Vi_Id:donviid,Ma_Ao:null,
            To_Chuc:false,Gioi_Tinh:null,Dia_Chi:null,Ngay_Sinh:null,Ngay_Sinh_S:null,Dien_Thoai:null,CMND_Ngay:null,CMND_NoiCap:null,CMND_So:null,Hom_Thu:null,Fax:null,
          Dien_Thoai_Nha: null, Dien_Thoai_Co_Quan: null, Ma_So_Thue: null, La_Nguoi_Lien_Lac: null, Tai_Khoan_Ngan_Hang: null, Ten_Ngan_Hang: null
          , Quan_He_Giao_Dich: null
        };    
        if(id === null)
        {
            console.log("vao loaddatainit" + id);
            this.repo.getRequest("api/doituong/SinhMaDoiTuong/" + nhomdoituongid + '/'+donviid)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Ma_Doi_Tuong = response;
            });
          this.doituongSelect.Trang_Thai = true;
        }
        else {
            console.log(id);
            this.repo.getRequest("api/doituongnguoi/getbyid/" + id)
            .subscribe(response => {  
                console.log(response);
                this.doituongSelect.Id = id;
                this.doituongSelect.Ma_Doi_Tuong = response.Ma_Doi_Tuong;
                this.doituongSelect.Ten_Doi_Tuong = response.Ten_Doi_Tuong;
                this.doituongSelect.Trang_Thai = response.Trang_Thai;
                this.doituongSelect.Ghi_Chu = response.Ghi_Chu;
                this.doituongSelect.Parent = response.Parent;
                this.doituongSelect.Ma_Ao = response.Ma_Ao;

                this.doituongSelect.To_Chuc = response.To_Chuc;
                this.doituongSelect.Gioi_Tinh = response.Gioi_Tinh;
                this.doituongSelect.Dia_Chi = response.Dia_Chi;
                this.doituongSelect.Ngay_Sinh = response.Ngay_Sinh;
                this.doituongSelect.Dien_Thoai = response.Dien_Thoai;
                this.doituongSelect.CMND_Ngay = response.CMND_Ngay;
                this.doituongSelect.CMND_NoiCap = response.CMND_NoiCap;
                this.doituongSelect.CMND_So = response.CMND_So;
                this.doituongSelect.Hom_Thu = response.Hom_Thu;
                this.doituongSelect.Fax = response.Fax;
                this.doituongSelect.Dien_Thoai_Nha = response.Dien_Thoai_Nha;
                this.doituongSelect.Dien_Thoai_Co_Quan = response.Dien_Thoai_Co_Quan;
               
                this.doituongSelect.Ma_So_Thue = response.Ma_So_Thue;
                this.doituongSelect.La_Nguoi_Lien_Lac = response.La_Nguoi_Lien_Lac;
              
               
                this.doituongSelect.Tai_Khoan_Ngan_Hang = response.Tai_Khoan_Ngan_Hang;
              this.doituongSelect.Ten_Ngan_Hang = response.Ten_Ngan_Hang;
              this.doituongSelect.Quan_He_Giao_Dich = response.Quan_He_Giao_Dich;

              
             
               
            }); 
        }
        
       
    }
   
    keyTenPress(event: any) { 
        if (event.which === 13) {
            this.slCapTren.focus();
            event.preventDefault();
          }
   }
    public closeModal(){
        this.save.emit(null);
    }
    public saveproduct() {
        if (this.doituongSelect.Ten_Doi_Tuong == null || this.doituongSelect.Ten_Doi_Tuong == "") {
            swal('Lỗi!', 'Vui lòng nhập tên đối tượng!.', 'error');
            return;
      }
      $('#loading').show();
        this.repo.postRequest("api/doituongnguoi/addorupdate",this.doituongSelect)
            .subscribe(response => {  
              console.log(response);
              $('#loading').hide();
              if (response != null && response.match('-')) {
                this.doituongSelect.Id = response;
                this.doituongSelect.CallForm = this.callForm;
                this.save.emit(this.doituongSelect);
              }
              else {
                swal('Lỗi!', response, 'error');
              }
            }); 
    }
   
    
   

   


}
